import React from "react";
import {RouteComponentProps, withRouter} from "react-router";
import { DescriptionModel } from "../../../../alerts/models/alert";
import {getNotificationMessage} from "../../../../helpers/notificationMessages";

interface SimpleNotificationProps extends RouteComponentProps {
    prefixClassName: string;
    notificationType: string;
    date: JSX.Element;
    message: DescriptionModel;
    testId: string;
}

function SimpleNotification(props: SimpleNotificationProps): JSX.Element {
    return (
        <div className={`${props.prefixClassName}-notification section ${props.notificationType.toLowerCase()}`} data-testid={`${props.prefixClassName}-${props.testId}`}>
            <p>{props.date} | {getNotificationMessage(props.message.code, props.message.attributes)}</p>
        </div>
    );
}

export default withRouter(SimpleNotification);